import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";
import { MedicionSchema } from "./MedicionSchema";
import { TipoMuestra } from "../utils/enums";

export const AnalisisLaboratorioSchema = yup.object().shape({
  orden: yup.number().required("errors.analisisLaboratorio.orden.required"),
  fecha: yup
    .date()
    .typeError("errors.analisisLaboratorio.fecha.required")
    .test("lt", "errors.analisisLaboratorio.fecha.test", (value, context) => {
      return true;
    })
    .required("errors.analisisLaboratorio.fecha.required")
    .default(new Date().toLocaleDateString()),
  protocolo: yup
    .string()
    .max(10, "errors.analisisLaboratorio.protocolo.max")
    .required("errors.analisisLaboratorio.protocolo.required")
    .default(""),
  laboratorio: yup
    .string()
    .max(100, "errors.analisisLaboratorio.laboratorio.max")
    .required("errors.analisisLaboratorio.laboratorio.required")
    .default(""),
  tipoMuestra: yup
    .object()
    .required("errors.analisisLaboratorio.tipoMuestra.required")
    .default(null),
  periodoMuestreo: yup
    .object()
    .when(["tipoMuestra"], ([tipoMuestra], schema) => {
      if (
        [TipoMuestra.COMPENSADA, TipoMuestra.COMPUESTA].indexOf(
          tipoMuestra?.codigo,
        ) >= 0
      ) {
        return schema
          .concat(CantidadSchema)
          .required("errors.analisisLaboratorio.periodoMuestreo.required")
          .test(
            "magnitud.min",
            "errors.cantidad.magnitud.min",
            (value, context) => {
              return value?.magnitud > 0;
            },
          )
          .default(null);
      } else {
        return schema.optional().nullable();
      }
    }),
  caudalMedio: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.analisisLaboratorio.caudalMedio.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ unidad: { codigo: "M3H" } }),
  resultados: yup
    .array()
    .of(MedicionSchema)
    .test(
      "DQORequerido",
      "errors.analisisLaboratorio.resultados.DQORequired",
      (value) =>
        !!value &&
        value instanceof Array &&
        !!value.find((medicion) => "DQO" === medicion?.contaminante?.codigo),
    )
    .test(
      "DBORequerido",
      "errors.analisisLaboratorio.resultados.DBORequired",
      (value) =>
        value &&
        value instanceof Array &&
        !!value.find((medicion) => "DBO" === medicion?.contaminante?.codigo),
    )
    .required("errors.analisisLaboratorio.resultados.required")
    .default([]),
});
